import React from 'react';
import { T } from '../../constants';
import { sizeCategory } from '../../helpers';

// Concentrate source-discipline size category (CAT 1/2/3 = 1.5/1.0/0.5×).
// Pass the decision row `d`; `system` forces the source when the row doesn't
// carry system_id (the per-strategy monitors know which book they are).
export default function SizeCatBadge({ d, system }) {
  const sc = sizeCategory(system ? { ...d, system_id: system } : d);
  if (!sc) return <span style={{ color: T.textMuted }}>—</span>;
  return (
    <span title={sc.tip} style={{
      display: 'inline-block', padding: '2px 8px', borderRadius: 4,
      fontSize: 10, fontWeight: 700, letterSpacing: '0.05em',
      whiteSpace: 'nowrap',
      background: `${sc.color}22`,
      border: `1px solid ${sc.color}66`,
      color: sc.color,
      fontFamily: 'Roboto Mono, monospace',
    }}>{sc.catLabel}</span>
  );
}
